/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Validation_Invalid_TokenInputs */



/**
* | output |
* | --- |
* | "Invalid setup token format" |
*
* @param {Form_Validation_Invalid_TokenInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const form_validation_invalid_token = /** @type {((inputs?: Form_Validation_Invalid_TokenInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Validation_Invalid_TokenInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültiges Format für Einrichtungs-Token")
	return /** @type {LocalizedString} */ ("Invalid setup token format")
});